import { CartActions } from './action';
import { CartMutations } from './mutations';

const states = () => ({
    cartSelected: null,
});

export default {
    actions: CartActions,
    mutations: CartMutations,
    namespaced: true,
    state: states,
};
